import { useQuery } from "@tanstack/react-query";
import { problemMessage, problemOf } from "../../../api/scholarships";
import { bursariesApi } from "../../../api/hliLists";

// Bursaries at public institutions in Rwanda: each institution's HLI admin uploads its admitted
// students in one sheet a year; HEC staff see every institution's uploads

export const PUBLIC_LOANS_KEY = ["bursaries", "uploads"];

// The sheet's problems as "Row 5: Registration number — …", from the 422 a refused upload returns
const COLUMN_LABELS = {
  registrationNumber: "Registration number",
  firstName: "First name",
  lastName: "Last name",
  gender: "Gender",
  nationalId: "National ID",
  collegeCode: "College code",
  collegeName: "College name",
  qualificationCode: "Qualification code",
  combinationCode: "Combination code",
};

// The upload sheet's columns, in the order the template gives them
export const SHEET_COLUMNS = [
  "registrationNumber",
  "firstName",
  "lastName",
  "gender",
  "nationalId",
  "phoneNumber",
  "email",
  "indexNumber",
  "dateOfBirth",
  "fatherNames",
  "motherNames",
  "ubudeheId",
  "s6Aggregate",
  "completionYearCode",
  "area",
  "campusName",
  "educationLevel",
  "collegeCode",
  "qualificationCode",
  "combinationCode",
];
export const rowProblemsOf = (problem) =>
  (problem?.errors ?? []).flatMap((e) => {
    const match = /^rows\[(\d+)\]\.(\w+)$/.exec(e.field ?? "");
    if (!match) return [];
    const column = match[2];
    return [{ row: Number(match[1]) + 2, column: COLUMN_LABELS[column] ?? column, message: problemMessage(e.code, problem.api) ?? "This value is not valid." }];
  });

const retry = (count, error) => problemOf(error)?.status !== 404 && problemOf(error)?.status !== 403 && count < 2;

// `scope`: "hli" for the HLI admin's own institution, "staff" for HEC
export const useUploads = (scope) =>
  useQuery({
    queryKey: [...PUBLIC_LOANS_KEY, scope],
    retry,
    queryFn: async () => (await (scope === "staff" ? bursariesApi.allUploads() : bursariesApi.myUploads())).data,
  });
